var _rect, _path, _path2, _g, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_8737)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 6,
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2741 -9L10.5181 5.56624H14.9995L21.0903 -9H16.2741Z",
    fill: "#6359CF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_8737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71777 4.66309H20.0728V22.0003H4.71777V4.66309Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_8737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41176 7.20299V5.93492C9.41176 5.72875 9.57911 5.56081 9.78477 5.56081H15.0061C15.2118 5.56081 15.3792 5.72875 15.3792 5.93492V7.20299C14.4619 6.8146 13.4537 6.59984 12.3955 6.59984C11.3372 6.59984 10.329 6.8146 9.41176 7.20299ZM16.2742 7.65345V5.93492C16.2742 5.23361 15.7052 4.66309 15.006 4.66309H9.7846C9.08535 4.66309 8.5165 5.23361 8.5165 5.93492V7.65345C6.24379 8.99044 4.71777 11.4666 4.71777 14.3001C4.71777 18.5528 8.15504 22.0003 12.3953 22.0003C16.6355 22.0003 20.0728 18.5528 20.0728 14.3001C20.0728 11.4666 18.5469 8.99044 16.2742 7.65345Z",
    fill: "url(#paint0_linear_246_8737)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3975 20.6022C8.89967 20.6022 6.0542 17.8094 6.0542 14.3764C6.0542 10.9432 8.89967 8.15039 12.3975 8.15039C15.8953 8.15039 18.7409 10.9432 18.7409 14.3764C18.7409 17.8094 15.8953 20.6022 12.3975 20.6022Z",
    fill: "url(#paint1_linear_246_8737)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4581 16.8438L12.5016 16.0207L10.5376 16.8257L10.7073 14.6901L9.34326 13.0505L11.4047 12.5536L12.5255 10.7354L13.6298 12.5639L15.6866 13.0798L14.3078 14.7067L14.4581 16.8438Z",
    fill: "#FFEFB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 -9H8.34942L15.2168 5.80118H10.1931L3 -9Z",
    fill: "#7367F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_8737",
    x1: 10.7648,
    y1: 2.42346,
    x2: 1.53732,
    y2: 15.8009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_8737",
    x1: 11.7848,
    y1: 5.85123,
    x2: 4.37156,
    y2: 15.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99912"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_8737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.435e275919c15a9b23c5828a040146de.svg";
export { ForwardRef as ReactComponent };